<template lang="pug">
v-card(elevation="1", class="pa-4", style="max-width: 400px;")
  // 標題 row
  v-row(no-gutters, align="center")
    v-col(cols="auto").color_444444
      span.p1-tc-500 {{$t('GPT_KNOWLEDGE.PROCESSING_FILE')}} ({{processingCount}}){{$t('GPT_KNOWLEDGE.TIP_7')}}
    v-spacer

  // 清單
  v-divider.my-2
  v-list(dense, style="max-height: 220px; overflow-y:auto;")
    v-list-item(
      v-for="(file, i) in files"
      :key="i"
      class="py-1 px-0"
      style="min-height:38px;"
    )
      v-list-item-avatar(width="32")
        v-icon(:color="file.type === 'PDF' ? 'red' : 'grey darken-1'") {{'mdi-file'}}
      v-list-item-content
        v-list-item-title(style="font-size: 15px;")
          | {{ file.file_name }}
      v-list-item-action
        // 狀態
        span(
          v-if="file.status === 'EMBEDDING'"
          class="blue--text text--darken-2"
          style="font-size:15px"
        ) Processing...
        span(
          v-else-if="file.status === 'FAIL'"
          class="red--text text--darken-1"
          style="font-size:15px"
        ) Failed
</template>
<script>
export default {
    props: {
    files: {
        type: Array,
        required: true,
    },
    },
  data() {
    return {
      fileTypeIcon: {
        'TXT': 'mdi-file-document-outline',
        'PDF': 'mdi-file-pdf-box',
      },
    }
  },
  computed: {
    processingCount() {
      return this.files.length
    }
  }
}
</script>